<template>
  <div class="jumbotron">
    <img
      class="jumbotron__img-small"
      src="@/assets/images/illustration-main-small.svg"
      :alt="$t('portal')"
    />
    <h1 class="h1">
      {{ title }}
    </h1>
    <h2 class="h2" v-if="!errorPage">
      {{ orgConfig("datasets.which_use") }}
    </h2>
    <div class="jumbotron__buttons btn-group" v-if="!errorPage">
      <Button :link="localizedLink('datasets')" type="primary">
        {{ $t("availableDatasets") }}
      </Button>
      <Button :link="localizedLink('documentation')" type="secondary">
        {{ $t("documentation") }}
      </Button>
    </div>
    <img
      class="jumbotron__img-big"
      src="@/assets/images/illustration-main.svg"
      :alt="$t('portal')"
    />
  </div>
</template>

<script>
import Button from "@/components/homepage/Button";

export default {
  components: {
    Button
  },
  props: {
    title: {
      type: String,
      required: true
    },
    errorPage: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.jumbotron {
  max-width: $--container-jumbotron;
  margin-left: auto;
  margin-right: auto;
  padding: 80px $--gutter-landing-width / 2 72px;
  @media (max-width: $breakpoint-xs - 1) {
    padding: 50px $--gutter-landing-width 40px;
  }

  .h2 {
    color: $--color-landing-primary;
  }

  img {
    display: block;
    margin-top: 63px;
    width: 100%;
  }

  .jumbotron__img-small {
    margin-top: 0;
    margin-bottom: 40px;
    @media (min-width: $breakpoint-xs) {
      display: none;
    }
  }

  .jumbotron__img-big {
    max-width: 70%;
    margin-left: auto;
    margin-right: auto;
    @media (max-width: $breakpoint-xs - 1) {
      display: none;
    }
  }
}

.jumbotron--small {
  max-width: $--container-jumbotron-small;
  overflow: hidden;
  padding-bottom: 0;
  @media (max-width: $breakpoint-xs - 1) {
    padding-top: 30px;
  }

  img {
    margin-top: -140px;
    pointer-events: none;
  }

  .jumbotron__img-small {
    margin-bottom: 0;
    width: calc(100% + 60px);
    max-width: calc(100% + 60px);
    margin-left: -30px;
    margin-right: -30px;
    margin-top: -8px;
    display: block;
    @media (min-width: $breakpoint-md) {
      display: none;
    }
  }

  .jumbotron__img-big {
    @media (max-width: $breakpoint-md - 1) {
      display: none;
    }
  }
}

.jumbotron__buttons {
  margin-top: 45px;
  text-align: center;
  @media (max-width: $breakpoint-xs - 1) {
    margin-top: 20px;
  }
}
</style>
